import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./../../../../assets/css/general/Homelayout/Courses/courses.css";

const Courses = () => {
  const navigate = useNavigate();

  const courses = [
    {
      id: 1,
      title: "Frontend Foundations",
      description:
        "Learn HTML, CSS, JavaScript, and modern UI practices to build responsive web interfaces.",
      level: "Beginner",
      duration: "6 Weeks",
      levelColor: "beginner",
    },
    {
      id: 2,
      title: "Backend & APIs",
      description:
        "Understand servers, databases, and REST APIs by building scalable backend systems.",
      level: "Intermediate",
      duration: "8 Weeks",
      levelColor: "intermediate",
    },
    {
      id: 3,
      title: "DSA & Interview Prep",
      description:
        "Master data structures, algorithms, and problem-solving for technical interviews.",
      level: "Advanced",
      duration: "10 Weeks",
      levelColor: "advanced",
    },
  ];

  return (
    <section className="hm-courses-section">
      <Container className="hm-courses-container">
        <Row>
          <Col xs={12}>
            <div className="hm-courses-header">
              <h2 className="hm-courses-heading">Explore Our Courses</h2>
              <p className="hm-courses-subtext">
                Start with structured learning paths designed to take you from
                fundamentals to job-ready skills.
              </p>
            </div>
          </Col>
        </Row>

        <Row className="hm-courses-grid g-4">
          {courses.map((course) => (
            <Col key={course.id} xs={12} md={6} lg={4}>
              <div className="hm-course-card">
                <div className="hm-course-content">
                  <h3 className="hm-course-title">{course.title}</h3>
                  <p className="hm-course-description">{course.description}</p>

                  <div className="hm-course-meta">
                    <span
                      className={`hm-course-level hm-course-level--${course.levelColor}`}
                    >
                      {course.level}
                    </span>
                    <span className="hm-course-duration">
                      {course.duration}
                    </span>
                  </div>
                </div>

                <button className="hm-course-action">View Course →</button>
              </div>
            </Col>
          ))}
        </Row>

        <Row>
          <Col xs={12}>
            <div className="hm-courses-footer">
              <button
                onClick={() => navigate("/courses")}
                className="hm-courses-cta"
              >
                View All Courses →
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Courses;
